// STAKE HOLDER DETAILS FUNCTIONS/////////
import axios from "axios";

export const listProspect = async () => {
  try {
    return await axios.get(
      `${process.env.REACT_APP_API_URL_ZIYA}/api/auth/prospect-list`
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const AddToWhislist = async ({ userid, productid }) => {
  try {
    return await axios.post(
      `${process.env.REACT_APP_API_URL_ZIYA}/api/auth/add-whislist-Items`,
      { userid, productid }
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const RemoveFromWhislist = async ({ userid, productid }) => {
  try {
    return await axios.post(
      `${process.env.REACT_APP_API_URL_ZIYA}/api/auth/remove-whislist-Items`,
      { userid, productid }
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const GetWhishlistUser = async (userid) => {
  try {
    return await axios.get(
      `${process.env.REACT_APP_API_URL_ZIYA}/api/auth/get-whislist-Items-user/${userid}`
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const createProspect = async (values) => {
  try {
    return await axios.post(
      `${process.env.REACT_APP_API_URL_ZIYA}/api/auth/prospect-create`,
      values
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProspect = async (_id) => {
  try {
    return await axios.get(
      `${process.env.REACT_APP_API_URL_ZIYA}/api/auth/get-prospect/${_id}`
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// export const getUserByWP = async (no) => {
//   return await axios.get(
//     `${process.env.REACT_APP_API_URL_MARWIZ}/api/auth/prospect-login/${no}`
//   );
// };

export const getUserByWP = async (ContactNo) => {
  try {
    return await axios.get(
      `${process.env.REACT_APP_API_URL_ZIYA}/api/auth/prospect-login/${ContactNo}`
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const removeProspect = async (_id) => {
  try {
    return await axios.delete(
      `${process.env.REACT_APP_API_URL_ZIYA}/api/auth/prospect-remove/${_id}`
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateProspect = async (user, prospect) => {
  try {
    
    return await axios.put(
      `${process.env.REACT_APP_API_URL_ZIYA}/api/auth/prospect-update/${user}`,
      prospect
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};
